import { Phone, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { companyInfo, whatsappLink } from '../data/mock';
import { WhatsAppIcon } from './WhatsAppIcon';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_laser-busters/artifacts/2ala9m3d_Screenshot_2026-01-31-00-11-44-62_92460851df6f172a4592fca41cc2d2e6.jpg";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="header-dark">
      <div className="flex items-center gap-3">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <img 
            src={LOGO_URL} 
            alt="Borer Busters Logo" 
            className="h-12 w-auto object-contain"
          />
        </div>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center gap-6">
        <button 
          onClick={() => scrollToSection('how-it-works')}
          className="body-small hover:text-gold-solid transition-colors cursor-pointer bg-transparent border-none"
          style={{ color: 'var(--text-muted)' }}
        >
          How It Works
        </button>
        <button 
          onClick={() => scrollToSection('comparison')}
          className="body-small hover:text-gold-solid transition-colors cursor-pointer bg-transparent border-none"
          style={{ color: 'var(--text-muted)' }}
        >
          Why Laser?
        </button>
        <button 
          onClick={() => scrollToSection('faq')}
          className="body-small hover:text-gold-solid transition-colors cursor-pointer bg-transparent border-none"
          style={{ color: 'var(--text-muted)' }}
        >
          FAQ
        </button>
      </nav>

      <div className="flex items-center gap-3">
        {/* Price Badge */}
        <div className="hidden sm:block">
          <span 
            className="text-xs font-display font-bold px-3 py-1 rounded"
            style={{ 
              background: 'linear-gradient(90deg, var(--gold-dark), var(--gold-primary))',
              color: 'var(--bg-dark)'
            }}
          >
            Starting ₹4,999
          </span>
        </div>
        
        <a 
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-whatsapp-btn"
          className="hidden sm:flex items-center gap-2 text-sm py-2 px-4 rounded font-display font-semibold transition-transform hover:-translate-y-0.5"
          style={{ 
            background: '#25D366',
            color: '#fff',
            textDecoration: 'none'
          }}
        >
          <WhatsAppIcon size={16} />
          <span>WhatsApp</span>
        </a>

        <a 
          href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
          data-testid="header-call-btn"
          className="btn-gold hidden sm:flex text-sm py-2 px-4"
        >
          <Phone size={16} />
          <span>Call Now</span>
        </a>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden p-2 bg-transparent border-none cursor-pointer"
          style={{ color: 'var(--gold-primary)' }}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div 
          className="absolute top-full left-0 right-0 md:hidden"
          style={{ 
            background: 'var(--bg-overlay)', 
            backdropFilter: 'blur(10px)',
            borderBottom: '1px solid var(--border-gold)'
          }}
        >
          <div className="flex flex-col p-4 gap-4">
            <button 
              onClick={() => scrollToSection('how-it-works')}
              className="body-medium text-left py-2 bg-transparent border-none cursor-pointer"
              style={{ color: 'var(--text-light)' }}
            >
              How It Works
            </button>
            <button 
              onClick={() => scrollToSection('comparison')}
              className="body-medium text-left py-2 bg-transparent border-none cursor-pointer"
              style={{ color: 'var(--text-light)' }}
            >
              Why Laser?
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="body-medium text-left py-2 bg-transparent border-none cursor-pointer"
              style={{ color: 'var(--text-light)' }}
            >
              FAQ
            </button>
            <div 
              className="text-center py-2 rounded font-display font-bold"
              style={{ 
                background: 'linear-gradient(90deg, var(--gold-dark), var(--gold-primary))',
                color: 'var(--bg-dark)'
              }}
            >
              Starting ₹4,999
            </div>
            <a 
              href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
              className="btn-gold"
            >
              <Phone size={16} />
              <span>Call {companyInfo.phone}</span>
            </a>
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-mobile-whatsapp-btn"
              className="flex items-center justify-center gap-2 py-3 px-4 rounded font-display font-semibold"
              style={{ 
                background: '#25D366',
                color: '#fff',
                textDecoration: 'none'
              }}
            >
              <WhatsAppIcon size={18} />
              <span>WhatsApp Us</span>
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
